import HealthBar from 'pages/Asset/tabs/Reports/components/HealthBar/Healthbar';
import { ReportPDFAsset } from 'queries/report/contract';

interface PdfAssetLineProps {
  asset: ReportPDFAsset;
  isParent?: boolean;
  newLine?: boolean;
  showHealthBar?: boolean;
  className?: string;
  children?: () => React.ReactNode;
}

const PdfAssetLine: React.FC<PdfAssetLineProps> = ({
  asset,
  isParent = false,
  newLine = false,
  showHealthBar,
  className = '',
  children,
}: PdfAssetLineProps) => {
  const treatedHealth = asset.health_score == null ? '0' : asset.health_score.toFixed(0);
  const href = `#${asset.id}`;
  const splitedName = asset.name.split(' - ');
  const formattedAssetName = splitedName.length > 1 ? splitedName.slice(1).join(' - ') : asset.name;

  return (
    <>
      <div
        className={`asset-line ${isParent ? 'asset-line-parent' : 'asset-line-child'} ${className}`}
      >
        <a className={'asset-line-link'} href={href}>
          {formattedAssetName}
        </a>
        {showHealthBar ? (
          <HealthBar health={treatedHealth} showText />
        ) : (
          <strong className="asset-line-health">{`${treatedHealth}%`}</strong>
        )}

        {!newLine && children?.()}
      </div>
      {newLine && children?.()}
    </>
  );
};

export default PdfAssetLine;
